import EllipsisTooltip from './EllipsisTooltip';

export default EllipsisTooltip;
